"use strict";

var React = require("react");

var SvgIconBoxSelect24Px = function SvgIconBoxSelect24Px() {
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
    },
    /*#__PURE__*/ React.createElement("path", {
      d: "M.016 1.11h24",
      stroke: "currentColor",
      strokeWidth: 2.2,
      strokeDasharray: "4.4,2.2",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M.015 22.917h24",
      stroke: "currentColor",
      strokeWidth: 2.199,
      strokeDasharray: "4.39821,2.1991",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M1.016.05v23.954M23.016.04v23.858",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeDasharray: "4,2",
    })
  );
};

exports["foreignIcon"] = SvgIconBoxSelect24Px;
